


























import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
import HolderEdit from '@/components/ProductVariantHolder/HolderEdit.vue';
import SPopup from '@/components/UI/Popup/SPopup.vue';

@Component({
  components: {
    HolderEdit,
  },
})
export default class HolderEditButton extends Vue {
  @Prop(String) private id!: string;
  private showDialog = false;

  @Ref() public parentPopup?: SPopup

  @Emit()
  private productVariantHolderUpdated() {
    this.showDialog = false;
  }
}
